import { render, staticRenderFns } from "./WarringDialog.vue?vue&type=template&id=a4ad0e4a&scoped=true"
import script from "./WarringDialog.vue?vue&type=script&lang=js"
export * from "./WarringDialog.vue?vue&type=script&lang=js"
import style0 from "./WarringDialog.vue?vue&type=style&index=0&id=a4ad0e4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ad0e4a",
  null
  
)

export default component.exports